<div>
  <p translate="tdWb.integration.marketsAndResearch.error"></p>
</div>
